import { useState } from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Typography, Grid, FormGroup, Box, Divider } from '@mui/material';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Collapse from '@mui/material/Collapse';
import { useTranslation } from 'next-i18next';

import CourseFilterCheckbox from './courseFilterCheckbox';
import Style from './style';

import ExpandMore from 'src/components/atoms/expandMore';
import ReadMore from 'src/components/atoms/readMore';
import { CourseFilterObjectProps, CourseAPIQueryProps, CourseFiltersKey } from 'src/interfaces/course';

export type Props = {
  object: CourseFilterObjectProps;
  handleFilters: (e: React.ChangeEvent<HTMLInputElement>, key: CourseFiltersKey) => void;
  courseApiQueries: CourseAPIQueryProps;
};

const CourseFilterItem = ({ object, handleFilters, courseApiQueries }: Props) => {
  const [isCardExpanded, setIsCardExpanded] = useState(true);
  const [isShowMoreExpanded, setIsShowMoreExpanded] = useState(false);

  const { t } = useTranslation();

  const handleCardExpandClick = () => {
    setIsCardExpanded(!isCardExpanded);
  };

  const handleShowMoreExpandClick = () => {
    setIsShowMoreExpanded(!isShowMoreExpanded);
  };

  return (
    <Style sx={{ width: '100%' }} className="filter-item-container">
      <Divider variant="middle" className={`filter-item-separator filter-${object.key}`} />
      <Box sx={{ my: 1, mx: 2 }}>
        <Grid container alignItems="center">
          <Grid item xs>
            <Typography variant="h4" component="div" className="title">
              {object.name}
            </Typography>
          </Grid>
          <Grid item>
            <ExpandMore
              expand={isCardExpanded}
              onClick={handleCardExpandClick}
              aria-expanded={isCardExpanded}
              aria-label="Show"
            >
              <ExpandMoreIcon />
            </ExpandMore>
          </Grid>
        </Grid>
      </Box>
      <Collapse in={isCardExpanded} timeout="auto" unmountOnExit>
        {!object.isShowMore ? (
          <CardContent sx={{ m: 0, pt: 0 }}>
            <FormGroup>
              {object.list.map((child, index) => (
                <CourseFilterCheckbox
                  handleFilters={handleFilters}
                  queryFilters={courseApiQueries}
                  key={child.name}
                  filterKey={object.key}
                  object={child}
                  isShowMore={isShowMoreExpanded}
                  index={index}
                />
              ))}
            </FormGroup>
          </CardContent>
        ) : (
          <>
            <Collapse in={isShowMoreExpanded} collapsedSize={42 * 5}>
              <CardContent sx={{ m: 0, pt: 0 }}>
                <FormGroup>
                  {object.list.map((child, index) => (
                    <CourseFilterCheckbox
                      handleFilters={handleFilters}
                      queryFilters={courseApiQueries}
                      key={child.name}
                      filterKey={object.key}
                      object={child}
                      isShowMore={isShowMoreExpanded}
                      index={index}
                    />
                  ))}
                </FormGroup>
              </CardContent>
            </Collapse>
            <CardActions disableSpacing sx={{ pb: 3, px: 2, pt: 0 }}>
              <ReadMore
                expand={isShowMoreExpanded}
                onClick={handleShowMoreExpandClick}
                aria-expanded={isShowMoreExpanded}
                aria-label="show more"
                title_expand={t('all_course.read_more.show')}
                title_unexpand={t('all_course.read_more.hide')}
              />
            </CardActions>
          </>
        )}
      </Collapse>
    </Style>
  );
};

export default CourseFilterItem;
